import {FC, ReactNode, useRef} from 'react';
import {Modal as MuiModal, ModalProps as MuiModalProps} from '@mui/material';
import BlankCard from 'components/BlankCard/BlankCard';
import './Modal.scss';

export interface ModalProps extends Omit<MuiModalProps, 'children'> {
  title: string;
  description?: string;
  small?: boolean;
  children?: ReactNode;
}

const Modal: FC<ModalProps> = ({
  className,
  children,
  title,
  description,
  small,
  open,
  ...other
}) => {
  const cardRef = useRef(null);
  if (!children) return null;
  return (
    <MuiModal
      open={open}
      className={`${className} ${small && 'small'} Modal`}
      {...other}
    >
      <BlankCard ref={cardRef} title={title} description={description}>
        {open && children}
      </BlankCard>
    </MuiModal>
  );
};

export default Modal;
